import { render, staticRenderFns } from "./SearchAutocomplete.vue?vue&type=template&id=422e8db2&scoped=true"
import script from "./SearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./SearchAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SearchAutocomplete.vue?vue&type=style&index=0&id=422e8db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e8db2",
  null
  
)

export default component.exports